export default __webpack_public_path__ + "static/media/portrait2.486b8006.png";